import { render } from "./LabelsList.vue?vue&type=template&id=09f19cdf&scoped=true"
import script from "./LabelsList.vue?vue&type=script&lang=js"
export * from "./LabelsList.vue?vue&type=script&lang=js"

import "./LabelsList.vue?vue&type=style&index=0&id=09f19cdf&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f19cdf"]])

export default __exports__